import ErrorBoundary from 'components/ErrorBoundary';
import { TravFooter, TravHeader } from 'components/shared';
import TimeoutModal from 'components/Timeout';
import { GlobalProvider } from 'context/GlobalProvider';
import { mockServer } from 'mock/mockServer';
import React, { useEffect } from 'react';
import AppRoutes from './routes/AppRoutes';
import 'styles/app.scss';
import { DEFAULTMENU } from 'utils/constants';
import { getEnvProperties, getTealiumHeaders } from './apis/pa-services';

if (process.env.REACT_APP_MOCK_API_TRUE) {
    console.log('test server');
    mockServer();
}

function App() {
    useEffect(() => {
        (async () => {
            const { data } = await getEnvProperties();
            if (data) {
                // eslint-disable-next-line no-undef
                cmSetClientID(data.coreMetricsId, data.prod, data.coreMetricsUrl, 'travelers.com');
            }
        })();
    }, []);

    useEffect(() => {
        (async () => {
            const tealiumHeader = await getTealiumHeaders();
            if (tealiumHeader?.tealiumenv) {
                let a =
                    `https://tags.tiqcdn.com/utag/travelers/premium-audit/` +
                    tealiumHeader.tealiumenv +
                    `/utag.js`;
                let b = document;
                let c = 'script';
                const script = b.createElement('script');
                script.src = a;
                script.type = 'text/java' + c;
                script.async = true;
                a = b.getElementsByTagName(c)[0];
                a.parentNode.insertBefore(script, a);
                if (!b.querySelector(`script[src='${a}']`)) {
                    b.body.appendChild(script);
                }
            }
        })();
    }, []);

    return (
        <div className="tds-app-wrapper">
            <div className="app-style-transactional tds-app-wrapper">
                <GlobalProvider>
                    <TimeoutModal>
                        <TravHeader />
                        <div role="main" className="tds-body">
                            <div className="tds-container page-layout">
                                <ErrorBoundary>
                                    <AppRoutes />
                                </ErrorBoundary>
                            </div>
                        </div>
                        <TravFooter footer={DEFAULTMENU.footer} />
                    </TimeoutModal>
                </GlobalProvider>
            </div>
        </div>
    );
}

export default App;
